import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#047481',
        secondary: '#516e8a',
        accent: '#6c8294',
        neutral: "#f5f5f5",
        anchor: '#047481',
        contrast: '#2c7a91',
        contrastMuted: '#507983',
      },
    },
  },
});
